export const SHOW_UPDATE_EVENT_REPORT_DIALOG = 'SHOW_UPDATE_EVENT_REPORT_DIALOG';

export const showUpdateEventReportDialog = (payload) => {
    return {
        type: SHOW_UPDATE_EVENT_REPORT_DIALOG,
        payload,
    };
};
